import React from 'react'
import person1 from './images/person-1.svg'
import person2 from './images/person-2.svg'
import person3 from './images/person-3.svg'
import person4 from './images/person-4.svg'
import { FaInstagramSquare, FaFacebook, FaLinkedin, FaTwitter, FaCamera, FaFile, FaImage, FaFolder, FaEnvelope, FaBell, FaSearch, FaBabyCarriage, FaShieldAlt } from 'react-icons/fa';
import completed from './images/Completed.svg'
import incomplete from './images/round.svg';
import dashboard from './images/dashboard.svg'
import profile2 from './images/profile-2.svg'
import assessment from './images/assessment.svg'
import jobs from './images/jobs.svg'
import settings from './images/settings.svg'
import album from './images/photo-album.png'
import folder from './images/folder.png'
import camera from './images/camera.svg'
import frame1 from './images/frame-1.svg'
import frame2 from './images/frame-2.svg'
import frame3 from './images/frame-3.svg'
import frame4 from './images/frame-4.svg'
import frame5 from './images/frame-5.svg'
import bell from './images/bell.png'
import jobalert from './images/alert.png'
import search from './images/search.png'
import envelope from './images/envelope.png'
import company1 from './images/company1.svg'
import company2 from './images/company2.svg'
import company3 from './images/company3.svg'
import gear from './images/8thgear.svg'
import opay from './images/opay.svg'
import location from './images/location.svg'
import slack from './images/slack.svg'
import zoom from './images/zoom.svg'
import amazon from './images/amazon.svg'


export const skills = [
  {
    id: 1,
    label:'Product Design',
  },
  
  {
    id: 2,
    label:'Software Development',
  },
  
  {
    id: 3,
    label:'Graphic Design',
  },
  {
    id: 4,
    label:'UI/UX Design',
  },
  {
    id: 5,
    label:'Data Science ',
  },

  {
    id: 6,
    label:'Project Management',
  },
]
export const viewedPosts = [
  {
    id:1,
    name:'John Doe',
    jobFunction:'Software Developer',
    postViewed: 'Mobile App Developer for Amazon',
    dateViewed:'10 hours ago',
    location: 'Abuja',
  },
  {
    id:2,
    name:'Victoria Samuel',
    jobFunction:'Product Designer',
    postViewed: 'UI Designer for Opay',
    dateViewed:'1 week ago',
    location: 'Lagos',
  },
  {
    id:3,
    name:'Jiwuaku Maria-goretti',
    jobFunction:'Frontend Developer',
    postViewed: 'Junior Frontend Developer for 8thGear Hub',
    dateViewed:'2 weeks ago',
    location: 'Lagos',
  },
]



export const locations = ['Abuja, Nigeria', 'Lagos, Nigeria', 'Ogun, Nigeria'];
export const industries = ['Marketing', 'IT', 'Environmental'];

export const jobOptions = [
  {
    id:1,
    role:'Marketing Specialist',
    industries: 'Marketing',
    company:'Slack',
    image: slack,
    location:'Lagos, Nigeria',
    datePosted:'2 days ago',
    amount:'N250,000 - N300,000',
    workMode: 'Remote',
    jobType: 'Part-Time',
    aboutUs: 'We are a communications company dedicated to connecting people and ideas. With a passion for innovative solutions, we deliver top-notch communication services to businesses and individuals alike. Let us help you stay connected and grow your network.',
    qualifications:['BSc. in marketing or any related field', '3 years experience', 'Professional certifications in marketing', 'Strong communication and project management skills are required, as well as expertise in marketing tools and techniques such as social media, email marketing, SEO, and analytics.'],
    jobDescription: ['Developing and executing marketing campaigns and strategies to promote a product or servic', 'Research market trends and competition to identify target audiences', 'Create compelling content and collateral, and manage digital and traditional marketing channels'],
  },
  {
    id:2,
    role:'Software Engineer',
    industries: 'IT',
    company:'8th Gear Hub',
    image: gear,
    location:'Abuja, Nigeria',
    datePosted:'2 weeks ago',
    amount:'N400,000 - N500,000',
    workMode: 'Remote',
    jobType: 'Part-Time',
    aboutUs: 'We are a tech company dedicated to delivering innovative solutions to complex problems. Our team of experts leverages cutting-edge technology to create intuitive and efficient products that transform the way people interact with the world.',
    qualifications:['BSc. in computer science or any related field', '3 years experience', 'Frontend - ReactJS, Typescript', ' Backend - NodeJS, Java', 'Build APIs'],
    jobDescription: ['Responsible for designing, developing, and maintaining software applications, systems, and platforms', 'Work with a team to analyze user needs, write code, and debug programs', 'Ensure that the software meets quality standards, is delivered on time, and within budget'], 
  },
  {
    id:3,
    role:'Product Manager',
    industries: 'IT',
    company:'Zoom',
    image: zoom,
    location:'Abuja, Nigeria',
    datePosted:'2 days ago',
    amount:'N700,000 - N800,000',
    jobType: 'Full-Time',
    workMode: 'Remote',
    aboutUs: 'We are a communications company dedicated to connecting people and ideas. With a passion for innovative solutions, we deliver top-notch communication services to businesses and individuals alike. Let us help you stay connected and grow your network.',
    qualifications:['BSc. in any field', '3 years experience', 'Professional certifications in product/project management', 'good team management skills'],
    jobDescription: ['Responsible for the planning, development, and execution of a company product vision', 'Work closely with cross-functional teams, including engineering, design, sales, and marketing, to identify customer needs, prioritize features', ' Create a roadmap for product development'], 
  },
  {
    id:4,
    role:'UI/UX Designer Intern',
    industries: 'IT',
    company:'Opay',
    image: opay,
    location:'Ogun, Nigeria',
    datePosted:'1 Hour ago',
    amount:'N100,000 - N150,000',
    jobType: 'Full-Time',
    workMode: 'Remote',
    aboutUs: 'We are a logistics company dedicated to delivering innovative solutions to complex problems. Our team of experts leverages cutting-edge technology to create intuitive and efficient products that transform the way people interact with the world.',
    qualifications:['BSc. in computer science or any related field', '0 years experience', 'Proficiency using Figma and/or Adobe XD'],
    jobDescription: ['Work closely with our design team to create intuitive and engaging digital experiences for our users', 'Assist in the design and development of wireframes, prototypes, and user interface designs for web and mobile applications', 'Participate in user research'], 
  },
  {
    id:5,
    role:'Environmental Specialist',
    industries: 'Environmental',
    company:'Amazon',
    image: amazon,
    location:'Lagos, Nigeria',
    datePosted:'18 hours ago',
    amount:'N350,000 - N500,000',
    jobType: 'Full-Time',
    workMode: 'Monday-Friday',
    aboutUs: 'We are an e-commerce company dedicated to providing customers with the best online shopping experience. With a wide range of products, secure payment options, and fast shipping, we strive to exceed expectations and make shopping easy and enjoyable.',
    qualifications:['BSc. in environmental studies or any related field', '5 years experience', 'Professional memberships with IEMA', 'NEBOSH, OSHA certified'],
    jobDescription: ['Responsible for ensuring compliance with environmental regulations', 'Developing and implementing environmental management systems, conducting environmental assessments', 'Providing technical expertise and support to minimize the impact of human activities on the environment'], 
  },
]

export const recommendedJobs = [
  {
    id: 1,
    image:gear,
    period:'Fulltime',
    icon: location,
    workMode:'Remote',
    role: 'Junior Frontend Developer (React)',
    company:'8th Gear Hub',
    amount:'N250,000 - N300,000',
    frequency:'Monthly',
  },
  {
    id:2 ,
    image:slack,
    period:'Internship',
    icon: location,
    workMode:'Onsite',
    role: 'Frontend Developer (JavaScript)',
    company:'Slack',
    amount:'N100,000 - N180,000',
    frequency:'Monthly',
  },
  {
    id: 3,
    image:zoom,
    period:'Freelance',
    icon: location,
    workMode:'Remote',
    role: 'Senior Fullstack Developer (React/NodeJS)',
    company:'Zoom',
    amount:'N500,000 - N750,000',
    frequency:'Monthly',
  },
  {
    id: 4,
    image:opay,
    period:'Fulltime',
    icon: location,
    workMode:'Remote',
    role: 'UI Designer',
    company:'Opay',
    amount:'N250-000 - N300,000',
    frequency:'Monthly',
  },
  {
    id: 5,
    image:amazon,
    period:'Fulltime',
    icon: location,
    workMode:'Remote',
    role: 'Mobile App Developer',
    company:'Amazon',
    amount:'N250-000 - N300,000',
    frequency:'Monthly',
  },
]
export const interviewJobs = [
  {
    id:1,
    image:gear,
    role:'Junior Frontend Developer',
    company:'8th Gear Hub',
    amount: 'N250,000 - N300,000',
    frequency: 'Monthly',
    period: 'Fulltime',
    workMode:'Onsite',
    icon: location,
    date:'23 March, 2023',
    time:'12 noon',
    venue: '1/3 Broad Street, VI, Lagos',
  },
  {
    id:2,
    image:opay,
    role:'Frontend Developer',
    company:'Opay',
    amount: 'N250,000 - N300,000',
    frequency: 'Monthly',
    period: 'Fulltime',
    workMode:'Remote',
    icon: location,
    date:'23 March, 2023',
    time:'12 noon',
    venue: 'Zoom',
  }
]

export const appliedJobs = [
  {
    id:1,
    image: company1,
    role:'Editorial Intern',
    companyName:'Vanguard Newspaper',
    location:'Nigeria',
    dateApplied:'Applied 2 weeks ago',
  },
  {
    id:2,
    image: company2,
    role:'Software Developer',
    companyName:'Meta Facebook',
    location:'Latin America',
    dateApplied:'Applied 2 months ago',
  },
  {
    id:3,
    image: company3,
    role:'UI/UX Designer',
    companyName:'Mildred Group',
    location:'France',
    dateApplied:'Applied 4 months ago',
  },
]

export const tests = [
  {
    id: 1,
    testImage: frame1,
    field: 'UI/UX Design',
    topics: ['Figma fundamentals', 'design thinking process', 'autolayout', 'design principles'],
    review: '500 people taken the test so far',
  },
  {
    id: 2,
    testImage: frame2,
    category:'Recommended',
    field: 'Frontend Development',
    topics: ['Javascript', 'React', 'HTML fundamentals', 'CSS'],
    review: '1000 people taken the test so far',
  },
  {
    id: 3,
    testImage: frame3,
    field: 'Microsoft Excel',
    topics: ['Data analysis', 'Formulas', 'Merging cells', 'Cell formatting' ],
    review: '400 people taken the test so far',
  },
  {
    id: 4,
    testImage: frame4,
    category:'Recommended',
    field: 'IT Infrastructure',
    topics: ['IT security', 'Server configuration', 'Routers and switches', 'Troubleshooting'],
    review: '200 people taken the test so far',
  },
  {
    id: 5,
    testImage: frame5,
    category:'Recommended',
    field: 'Backend Development',
    topics: ['NodeJS', 'Database setup', 'Queries', 'SQL Server'],
    review: '800 people taken the test so far',
  },
]


export const DropdownMenu = [
  {
    id: 1,
    icon:album,
    text:'Photo Library',
    
  },
  {
    id: 2,
    icon:camera,
    text:'Take Photo',
  },
  {
    id: 3,
    icon:folder,
    text:'Choose File',
  },
]

export const EmployerCollapsedMenu = [
  {
    id: 1,
    icon:dashboard,
    text:'Dashboard',
    url:'/employerdashboard' 
  },
  {
    id: 2,
    icon:profile2,
    text:'Profile',
    url:'/employerprofile'
  },
  {
    id: 3,
    icon:jobs,
    text:'Post Jobs',
    url:'/postjobs'
  },
  {
    id: 4,
    icon:jobalert,
    text:'Post Feedbacks',
    url:'/feedback'

  },
  
  {
    id: 5,
    icon:envelope,
    text:'Messages',
    url:'/employermessages'

  },
  {
    id: 6,
    icon:bell,
    text:'Notifications',
    url:'/employernotifications'

  },
  
 
]

export const CollapsedMenu = [
  {
    id: 1,
    icon:dashboard,
    text:'Dashboard',
    url:'/dashboard' 
  },
  {
    id: 2,
    icon:profile2,
    text:'Profile',
    url:'/jobseekerprofile'
  },
  {
    id: 3,
    icon:jobs,
    text:'My Jobs',
    url:'/jobs'
  },
  {
    id: 4,
    icon:search,
    text:'Find Jobs',
    url:'/find'

  },
  {
    id: 5,
    icon:assessment,
    text:'Assessments',
    url:'/assessments'
  },
  {
    id: 6,
    icon:envelope,
    text:'Messages',
    url:'/messages'

  },
  {
    id: 7,
    icon:bell,
    text:'Notifications',
    url:'/notifications'

  },
  {
    id: 8,
    icon:jobalert,
    text:'My Job Alerts',
    url:'/jobalert'

  },
  // {
  //   id: 9,
  //   icon:settings,
  //   text:'Settings',
  //   url:'/settings'

  // },
]



export const SidebarMenu = [
  {
    id: 1,
    icon:dashboard,
    text:'Dashboard',
    url:'/dashboard' 
  },
  {
    id: 2,
    icon:profile2,
    text:'Profile',
    url:'/jobseekerprofile'
  },
  {
    id: 3,
    icon:jobs,
    text:'My Jobs',
    url:'/jobs'
  },
  {
    id: 4,
    icon:assessment,
    text:'Assessments',
    url:'/assessments'
  },
  // {
  //   id: 5,
  //   icon:settings,
  //   text:'Settings',
  //   url:'/settings'

  // },
]


export const ProfileInfo = [
  {
    id:1,
    label:'About Me',
    placeholder:'Give an overview about yourself, work experience and skills'
  },
  {
    id:2,
    label:'Work Experience',
    placeholder:'Add your Work Experience. Such as an internship, part-time work or long term specialised experience.'
  },
  {
    id:3,
    label:'Education',
    placeholder:'List your qualifications here'
  },
  {
    id:4,
    label:'Job Function',
    placeholder:'What positions are you looking for in your field'
  },
  {
    id:5,
    label:'Job Skills',
    placeholder:'List your areas of expertise'
  },
]
export const ProfileInfoPercentage = [
  {
    id:1,
    icon: incomplete,
    text: 'About Me',
    percentage: '10%',
  },
  {
    id:2,
    icon: completed,
    text: 'Availability',
    percentage: '60%',
  },
  {
    id:3,
    icon: incomplete,
    text: 'Work Experience',
    percentage: '20%',
  },
  {
    id:4,
    icon: incomplete,
    text: 'Education',
    percentage: '10%',
  },
  {
    id:5,
    icon: completed,
    text: 'CV upload',
    percentage: '5%',
  },
  {
    id:6,
    icon: incomplete,
    text: 'Job Skills',
    percentage: '30%',
  },
  {
    id:7,
    icon: incomplete,
    text: 'Job Function',
    percentage: '20%',
  },
]

export const Testimonies = [
    {
        id: 1,
        testimonyImage: person1,
        info:'This platform was super helpful and communicative. I got update on all my applications',
        name: 'Micheal',
        type:'Job Seeker'
    },
    {
        id: 2,
        testimonyImage: person2,
        info:'My Job search with Jobbers Lens was flawless. The stress of finding a new job was eliminated',
        name: 'Allison',
        type:'Job Seeker'
    },
    {
        id: 3,
        testimonyImage: person3,
        info:'Hiring Process through Jobbers Lens has saved me time and helped me hire the right talent',
        name: 'Jackie',
        type:'Employer'
    },
    {
        id: 4,
        testimonyImage: person4,
        info:'I was able to hire a suitable talent. I’ll recommend to other employers',
        name: 'Susan',
        type:'Employer'
    },
]

export const socials = [
    {
      id: 1,
      url: 'https://www.facebook.com',
      icon: <FaFacebook/>,
    },
    {
      id: 2,
      url: 'https://www.twitter.com',
      icon: <FaTwitter/>,
    },
    {
      id: 3,
      url: 'https://www.instagram.com',
      icon: <FaInstagramSquare/>,
    },
    {
      id: 4,
      url: 'https://www.linkedin.com',
      icon: <FaLinkedin/>,
    },
  ];

  export const footers = [
    {
      id: 1,
      text: 'Contact Us',
    },
    {
      id: 2,
      text: 'FAQ',
    },
    {
      id: 3,
      text: 'Job Seeker',
    },
    {
      id: 4,
      text: 'Privacy Policy',
    },
    {
      id: 5,
      text: 'Employer',
    },
    {
      id: 6,
      text: 'Terms of Use',
    },
  ];


export const EmployerInfo = [
  
  {
    id:2,
    label:'Company Name',
    placeholder:'Add your company Name.'
  },
  {
    id:3,
    label:'Website Url',
    placeholder:'Enter your company website'
  },
  {
    id:4,
    label:'Company Type',
    placeholder:'The type of company'
  },
  
  {
    id:5,
    label:'Location',
    placeholder:'Location of your company'
  },
  {
    id:6,
    label:'Description',
    placeholder:'General Description of your company'
  },
]

export const EmployerInfoPercentage = [
  
  {
    id:2,
    icon: completed,
    text: 'Company name',
    percentage: '60%',
  },
  {
    id:3,
    icon: incomplete,
    text: 'Website Url',
    percentage: '20%',
  },
  {
    id:4,
    icon: incomplete,
    text: 'Company Type',
    percentage: '10%',
  },
 
  {
    id:5,
    icon: incomplete,
    text: 'Location',
    percentage: '30%',
  },
  {
    id:6,
    icon: incomplete,
    text: 'Description',
    percentage: '20%',
  },
]